<template lang="pug">
el-breadcrumb.app-breadcrumb(separator='/')
  transition-group(name='breadcrumb')
    el-breadcrumb-item(v-for='(item,index)  in levelList', :key='item.path', v-if='item.meta.title')
      span.no-redirect(v-if='item.redirect==="noredirect"||index==levelList.length-1') {{item.meta.title}}
      router-link(v-else='', :to='item.redirect||item.path') {{item.meta.title}}
</template>

<script>
export default {
  name: 'ElementBeradcrumb',
  data () {
    return {
      levelList: null
    }
  },
  methods: {
    getBreadcrumb () {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      if (first && first.name !== 'dashboard') {
        matched = [{path: '/dashboard', meta: {title: 'dashboard'}}].concat(matched)
      }
      this.levelList = matched
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
  created () {
    this.getBreadcrumb()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Element/Breadcrumb/index.vue